import BaseModel from './BaseModel'
import {computed, makeObservable, observable} from 'mobx'

export default class ClassDay extends BaseModel {

  constructor(day) {
    super();
    makeObservable(this, {
      is_on: observable,
      name: observable,
      time_from: observable,
      time_to: observable,
      is_valid: computed,
    })
    this.name = day
  }
  is_on = false;
  name = 'monday';
  time_from = null;
  time_to = null;
  
  get is_valid() {

    let valid = true;
    if (this.is_on) {
      if (!this.time_from || !this.time_to) {
        valid = false;
      }
    }
    return valid
  }
}